import * as React from "react";
import * as moment from "moment";
import type { ICustomerHomePageProps } from ".";
import { AppTextLabel } from "@@services/i18nservice";

import "./licencewarning.less";

export interface ILicenceInfo {
    isExpired: boolean;
    secondsLeft: number,
    i18n: string;
    inject: {
        days: string;
    }
}

export function licenceExpiration(customer):  ILicenceInfo {
    const licenceExpired = customer?.detail
    && ((Object.prototype.hasOwnProperty.call(customer.detail, "licenseIsActive")
        && customer.detail.licenseIsActive === false)
    || (customer.detail?.licenseEndDate
        ? moment().isAfter(moment(customer?.detail?.licenseEndDate)) : false));
    const today = moment();
    const daysRemaining = customer?.detail?.licenseEndDate
        ? moment(customer?.detail?.licenseEndDate).diff(today, "seconds") : null;
    const fromNow = moment(customer?.detail?.licenseEndDate).fromNow();
    return {
        isExpired: licenceExpired,
        secondsLeft: daysRemaining,
        i18n: "customer.warning.licensewillexpire.morethanoneday",
        inject: {
            days: fromNow
        }
    };
}


export function LicenceWarnings(props: ICustomerHomePageProps & {licenseInfo: ILicenceInfo}) {
    const licenseInfo = props.licenseInfo;
    
    return <>
        {licenseInfo.secondsLeft !== null && licenseInfo.secondsLeft <= 0
            ? <div className="customer-warning-banner">
                <i className="inwink-warning" />
                <div className="inwink-warning-text">
                    <AppTextLabel i18n="customer.warning.licenseexpired" component="h2" />
                    <AppTextLabel i18n="customer.warning.licenseexpired.description" component="h3" />
                </div>
            </div> : null}
        {(licenseInfo.secondsLeft !== null && licenseInfo.secondsLeft <= 5184000 && licenseInfo.secondsLeft > 0)
            ? <div className="customer-warning-banner">
                <i className="inwink-warning" />
                <div className="inwink-warning-text">
                    <AppTextLabel i18n={licenseInfo.i18n} inject={{days: licenseInfo.inject.days}} component="h2" />
                    <AppTextLabel i18n="customer.warning.licensewillexpire.description" component="h3" />
                </div>
            </div> : null}
    </>;
}
